import styles from "./index.module.css";
import React, {useRef} from "react";
import { motion } from "framer-motion";
import dynamic from "next/dynamic";
import { BriefcaseBusiness, FileUser } from "lucide-react";

const NoSSREcoScore = dynamic(() => import('./EcoScore'), { ssr: false })

const Social = (props) =>{

    const socials = useRef([
        {
            icon: "/img/linkedin.webp",
            name: "Linkedin",
            link: "https://www.linkedin.com/in/axel-g-4110ba1b0/"
        },
        {
            icon: "/img/github.webp",
            name: "Github",
            link: "https://github.com/Axel77g"
        },
        {
            icon: BriefcaseBusiness,
            name: "Mon\u00A0CV",
            link: "https://axelgodefroy.fr/cv"
        }
    ])

    return (
        <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7,duration: 0.5 }}
            className={styles.social}>
            {socials.current.map((e, i) => {
                return (
                    <a href={e.link} key={i}>
                        {typeof e.icon === "string" ? (
                            <img width={32} height={32} src={e.icon} alt={e.name + ' social network icon'}/>
                        ) : (
                            <div style={
                                {width: 28, height: 28, display: "flex", alignItems: "center", justifyContent: "center", background: "black", borderRadius: "50%"}
                            }>
                                <e.icon fill="white" width={18} height={18} color="black"/>
                            </div>
                        )}
                        <span className={styles.networkSpan}>{e.name}</span>
                    </a>
                )
            })}

            <NoSSREcoScore/>
        </motion.div>
    )
}

export default Social;